import React, { Fragment, Component } from 'react';
import { ReactComponent as IconClose } from '../../img/close.svg';
import { BoxMessageStyle } from './style/BoxMessageStyle';

export default class BoxMessage extends Component {
	state = {
		showMessage: true,
	};

	componentDidMount() {
		if (localStorage.getItem('hide-message')) {
			this.setState({ showMessage: false });
		}
	}

	closeMessage = () => {
		localStorage.setItem('hide-message', true);

		if (localStorage.getItem('hide-message')) {
			this.setState({ showMessage: false });
		}
	};

	render() {
		const { showMessage } = this.state;
		const { children } = this.props;

		return (
			<Fragment>
				<BoxMessageStyle>
					<div className={`box-about ${showMessage ? 'd-block' : 'd-none'} box-message`}>
						<div className="btn-close" tabIndex="0" role="button" onClick={this.closeMessage} onKeyPress={this.closeMessage}>
							<IconClose width={15} height={15} />
						</div>

						{ children }

						<span className="btn-agreed" tabIndex="0" role="button" onClick={this.closeMessage} onKeyPress={this.closeMessage}>
							OK, Entendi!
						</span>
					</div>
				</BoxMessageStyle>
			</Fragment>
		);
	}
}
